import React, { useState, useEffect, useRef, useCallback } from 'react';
import './ChatDetail.css';
import MessagePippip from './Item/MessagePippip';
import MessageUser from './Item/MessageUser';
import SuggestionAndNotification from './Item/SuggestionAndNotification';
import { useParams, useNavigate } from 'react-router-dom';
import ChatInput from '../../Component/ChatInput/ChatInput';
import { notification } from 'antd';

export default function ChatDetail() {
    const { groupid: paramGroupId } = useParams();
    const navigate = useNavigate();
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [groupId, setGroupId] = useState(paramGroupId || null);
    const [step, setStep] = useState(1);
    const [notice, setNotice] = useState('');
    const [isFetchingStep, setIsFetchingStep] = useState(false);
    const [isSending, setIsSending] = useState(false);

    // STT (live Gladia)
    const [isRecording, setIsRecording] = useState(false);
    const [recognizing, setRecognizing] = useState(false);
    const [partialText, setPartialText] = useState('');
    const audioStreamRef = useRef(null);
    const recorderRef = useRef(null);
    const wsRef = useRef(null);
    const gladiaSessionPromiseRef = useRef(null);
    const SAMPLE_RATE = 16000;
    const recordingTimeoutRef = useRef(null);

    const initRan = useRef(false);
    const messagesEndRef = useRef(null);

    // vi time format
    const formatVNTime = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        const vietnamOffset = 7 * 60;
        const localOffset = date.getTimezoneOffset();
        const vietnamTime = new Date(date.getTime() + (vietnamOffset + localOffset) * 60000);
        return vietnamTime.toLocaleString('vi-VN', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const parseContactInfo = (contactInfo) => {
        if (!contactInfo) {
            return ['', ''];
        }
        const info = contactInfo.trim();

        // Name - Phone
        const suffixPhoneRegex = info.match(/([\d\s().+-]+)$/);
        if (suffixPhoneRegex) {
            const potentialPhonePart = suffixPhoneRegex[0];
            const cleanedPhone = potentialPhonePart.replace(/\D/g, '');
            if (cleanedPhone.length === 10) {
                const customer_phone = cleanedPhone;
                const namePart = info.substring(0, info.length - potentialPhonePart.length);
                const customer_name = namePart.trim().replace(/[^a-zA-Z0-9]+$/, '');
                return [customer_name, customer_phone];
            }
        }

        // Phone - Name
        const prefixPhoneRegex = info.match(/^([\d\s().+-]{6,})\s*[-–—:]?\s*(.+)$/);
        if (prefixPhoneRegex) {
            const potentialPhonePart = prefixPhoneRegex[1];
            const rest = prefixPhoneRegex[2] || '';
            const cleanedPhone = potentialPhonePart.replace(/\D/g, '');
            if (cleanedPhone.length === 10) {
                const customer_phone = cleanedPhone;
                const customer_name = rest.trim().replace(/^[^a-zA-Z0-9]+/, '').replace(/[^a-zA-Z0-9]+$/, '');
                return [customer_name, customer_phone];
            }
        }

        // return full string as name, empty phone
        return [info, ''];
    };

    const handleSuggestionClick = (suggestion) => {
        setInput(suggestion);
        setNotice('');
    };

    // xóa groupid trong localStorage 
    const clearLocalGroupId = (groupId) => {
        const savedChats = JSON.parse(localStorage.getItem("chatHistory") || "{}");
        if (savedChats[groupId]) {
            delete savedChats[groupId];
            localStorage.setItem("chatHistory", JSON.stringify(savedChats));
            window.dispatchEvent(new Event("chatHistoryUpdated"));
        }
    }

    // show error notification
    const showError = (message) => {
        notification.error({
            message: 'Lỗi xảy ra',
            description: message || 'Đã có lỗi không xác định.',
            placement: 'topRight',
            duration: 3,
        });
    }

    // # gettextfromstep
    const handleGetTextFromStep = async (currentStep, currentGroupId) => {
        setIsFetchingStep(true);
        try {
            const nextStepRes = await fetch(
                `${process.env.REACT_APP_API_SERVER_URL}/chat/gettextfromstep?step=${currentStep}`,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            const nextStepData = await nextStepRes.json();

            if (currentStep >= 7) {
                await fetch(`${process.env.REACT_APP_API_SERVER_URL}/chat/sendmessage`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        message: nextStepData.message,
                        step: currentStep,
                        sender: 0,
                        groupid: currentGroupId
                    })
                });
            }

            setMessages(prevMessages => [
                ...prevMessages,
                { sender: '0', message: nextStepData.message, step: currentStep, created_at: new Date().toISOString() }
            ]);

            return nextStepData;
        } catch (error) {
            console.error(`Error in gettextfromstep step ${currentStep}:`, error);
            throw error;
        } finally {
            setIsFetchingStep(false);
        }
    };

    // # getgroupdetail
    // Lấy lại toàn bộ conversation
    const reloadConversation = async (targetGroupId) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_SERVER_URL}/chat/getgroupdetail/${targetGroupId}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await res.json();
            if (!data || !data.list_message) {
                clearLocalGroupId(targetGroupId);
                localStorage.setItem(
                    'chat_error_msg',
                    'Cuộc trò chuyện không tồn tại hoặc đã bị xoá. Đã chuyển về tạo cuộc trò chuyện mới.'
                );
                navigate('/chat/new');
                window.location.reload();

            } else {
                const historyMessages = data.list_message.map(m => ({
                    sender: m.sender.toString(),
                    message: m.message,
                    step: m.mess_step,
                    created_at: m.created_at
                }));

                setMessages(historyMessages);
                setStep(data.group_step+1);
                return { data, historyMessages };
            }
        } catch (error) {
            console.error('Error getgroupdetail:', error);
            throw error;
        }
    };

    // # createquotation
    const handleCreateQuotation = async (historyMessages, targetGroupId) => {
        try {
            const userMessages = historyMessages.filter(msg => msg.sender === '1'); // only user messages
            const member = userMessages.find(msg => msg.step === 1)?.message || '';
            const pickup_time = userMessages.find(msg => msg.step === 2)?.message || '';
            const pickup_address = userMessages.find(msg => msg.step === 3)?.message || '';
            const destination = userMessages.find(msg => msg.step === 4)?.message || '';
            const return_time = userMessages.find(msg => msg.step === 5)?.message || '';
            const contact_info = userMessages.find(msg => msg.step === 6)?.message || '';
            const [customer_name, customer_phone] = parseContactInfo(contact_info);
            const quotationPayload = {
                member, pickup_time, pickup_address, destination, return_time, customer_name, customer_phone
            };

            // createquotation
            // Gọi API tạo báo giá
            const quotationRes = await fetch(`${process.env.REACT_APP_API_SERVER_URL}/orderquotation/create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(quotationPayload)
            });
            const quotationData = await quotationRes.json();

            // Gửi link báo giá hoặc error message
            const messageText = quotationData.data?.link
                ? quotationData.data.link
                : 'Xin lỗi, có lỗi xảy ra khi tạo báo giá. Vui lòng thử lại sau.';

            await fetch(`${process.env.REACT_APP_API_SERVER_URL}/chat/sendmessage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    message: messageText,
                    step: 7,
                    sender: 0,
                    groupid: targetGroupId
                })
            });

            await reloadConversation(targetGroupId);

        } catch (error) {
            console.error('Error createquotation:', error);

            try {
                await fetch(`${process.env.REACT_APP_API_SERVER_URL}/chat/sendmessage`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        message: 'Xin lỗi, có lỗi xảy ra khi tạo báo giá. Vui lòng thử lại sau.',
                        step: 7,
                        sender: 0,
                        groupid: targetGroupId
                    })
                });
                await reloadConversation(targetGroupId);
            } catch (sendError) {
                console.error('Error sending error message:', sendError);
            }
        }
    };

    const saveLastChatToLocal = (groupId, lastMessage) => {
        const savedChats = JSON.parse(localStorage.getItem("chatHistory") || "{}");
        savedChats[groupId] = {
            groupId,
            lastMessage,
            savedAt: new Date().toISOString()
        };
        localStorage.setItem("chatHistory", JSON.stringify(savedChats));
        window.dispatchEvent(new Event("chatHistoryUpdated"));
    };

    // # sendmessage (userMessage only)
    const handleSendMessage = async (messageToSendFromInput) => {
        if (isFetchingStep || isSending) {
            setNotice('Vui lòng chờ bot phản hồi hoặc tin nhắn đang được gửi.');
            return;
        }

        let userMessage = messageToSendFromInput.trim();
        if (!userMessage) return;

        setIsSending(true); // Đặt cờ đang gửi
        setInput(''); // Xóa input trong UI ngay lập tức
        setNotice('');

        try {
            let stepToSend = step;

            // Step 6: Parse contact info: Name - Phone
            if (stepToSend === 6) {
                const [customer_name, customer_phone] = parseContactInfo(userMessage);
                if (!customer_name || !customer_phone || customer_phone.length !== 10) {
                    let errorMessage = '';
                    if (!customer_name && (!customer_phone || customer_phone.length !== 10)) {
                        errorMessage = 'Vui lòng nhập đúng định dạng: Tên - Số điện thoại (10 số)';
                    } else if (!customer_name) {
                        errorMessage = 'Vui lòng nhập tên khách hàng';
                    } else if (!customer_phone || customer_phone.length !== 10) {
                        errorMessage = 'Vui lòng nhập số điện thoại đúng (10 số)';
                    }

                    setNotice(errorMessage);
                    setInput(userMessage);
                    setIsSending(false);
                    return;
                }
                userMessage = `${customer_name} - ${customer_phone}`;
            }

            const payload = {
                message: userMessage,
                step: stepToSend,
                sender: 1,
                groupid: (paramGroupId && paramGroupId !== 'new') ? paramGroupId : null
            };

            const res = await fetch(`${process.env.REACT_APP_API_SERVER_URL}/chat/sendmessage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();

            if (!paramGroupId || paramGroupId === 'new') {
                navigate(`/chat/${data.groupid}`);
            }
            setGroupId(data.groupid);

            const { data: detailData, historyMessages } = await reloadConversation(data.groupid);

            // Lưu đoạn chat cuối cùng vào localStorage
            const lastUserMessage = historyMessages.filter(m => m.sender === '1').pop();
            if (lastUserMessage) {
                saveLastChatToLocal(data.groupid, lastUserMessage.message);
            }

            if (detailData.group_step <= 6) {
                await handleGetTextFromStep(detailData.group_step+1, data.groupid);

                if (detailData.group_step === 6) {
                    setTimeout(() => {
                        handleCreateQuotation(historyMessages, data.groupid);
                    }, 1000);
                }
            }
        } catch (error) {
            console.error('Error sending message:', error);
            setInput(userMessage);
        } finally {
            setIsSending(false);
        }
    };

    // === HOOKS ===
    useEffect(() => {
        const msg = localStorage.getItem('chat_error_msg');
        if (msg) {
            showError(msg);
            localStorage.removeItem('chat_error_msg');
        }
    }, []);

    useEffect(() => {
        if (initRan.current === true) {
            return;
        }

        const initializeChat = async () => {
            if (!paramGroupId || paramGroupId === 'new') {
                try {
                    // local user message (not send to server)
                    setMessages(prev => [
                        ...prev,
                        { sender: '1', message: 'Tôi muốn đặt xe', step: 1, created_at: new Date().toISOString() }
                    ]);

                    await handleGetTextFromStep(1, null);
                    setStep(1);
                } catch (error) {
                    console.error('Error initializing new chat:', error);
                }
            } else if (paramGroupId && paramGroupId !== 'new') {
                try {
                    const { data } = await reloadConversation(paramGroupId);
                    setGroupId(data.groupid);
                    if (data.group_step < 7) {
                        await handleGetTextFromStep(data.group_step+1, data.groupid);
                    }
                } catch (error) {
                    console.error('Error loading conversation:', error);
                }
            }
        };

        initializeChat();

        return () => {
            initRan.current = true;
            // Dừng ghi âm nếu component bị unmount trong khi đang ghi
            try {
                // cleanup recorder
                if (recorderRef.current) {
                    try { recorderRef.current.destroy(); } catch (_) { /* ignore */ }
                    recorderRef.current = null;
                }
                // close websocket
                if (wsRef.current) {
                    try {
                        wsRef.current.onopen = null;
                        wsRef.current.onmessage = null;
                        wsRef.current.onerror = null;
                        wsRef.current.onclose = null;
                        wsRef.current.close();
                    } catch (_) { /* ignore */ }
                    wsRef.current = null;
                }
                if (audioStreamRef.current) {
                    audioStreamRef.current.getTracks().forEach(track => track.stop());
                    audioStreamRef.current = null;
                }
            } catch (e) { /* ignore */ }
        };
    }, [paramGroupId]);

    useEffect(() => {
        if (messages.length === 2) {
            // Nếu chỉ có 2 tin nhắn (tin nhắn đầu tiên của hệ thống) -> scroll lên trên
            window.scrollTo(0, 0);
        } else if (messages.length > 1) {
            // Các tin nhắn sau -> scroll xuống dưới
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages]);

    useEffect(() => {
        if (notice) {
            const timer = setTimeout(() => {
                setNotice('');
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [notice]);

    // === Live STT (Gladia) ===
    const initiateGladiaLiveSession = useCallback(async () => {
        const apiKey = process.env.REACT_APP_SPEECH_API_KEY;
        const response = await fetch('https://api.gladia.io/v2/live', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-GLADIA-KEY': apiKey },
            body: JSON.stringify({ sample_rate: SAMPLE_RATE })
        });
        if (!response.ok) {
            const text = await response.text();
            throw new Error(`${response.status} ${text}`);
        }
        return response.json();
    }, []);

    const stopLiveRecording = useCallback((mergePartial = true) => {
        if (!isRecording && !recognizing) return;
        setNotice('Đang dừng ghi âm...');
        try {
            if (recordingTimeoutRef.current) {
                clearTimeout(recordingTimeoutRef.current);
                recordingTimeoutRef.current = null;
            }
            if (recorderRef.current) {
                try { recorderRef.current.stopRecording(() => { recorderRef.current?.destroy(); }); } catch (_) { }
            }
            if (audioStreamRef.current) {
                audioStreamRef.current.getTracks().forEach(t => t.stop());
                audioStreamRef.current = null;
            }
            if (wsRef.current) {
                try { wsRef.current.close(); } catch (_) { }
                wsRef.current = null;
            }
            if (mergePartial && partialText) {
                setInput(prev => (prev ? prev + ' ' + partialText : partialText));
            }
            setIsRecording(false);
            setRecognizing(false);
            setPartialText('');
            setNotice('Đã dừng ghi âm');
            gladiaSessionPromiseRef.current = null;
        } catch (err) {
            console.error('stopLiveRecording error', err);
            setNotice('Lỗi khi dừng ghi âm');
        }
    }, [isRecording, recognizing, partialText]);

    const startLiveRecording = useCallback(async () => {
        if (isRecording) return;
        setNotice('Đang khởi tạo nhận dạng...');
        setRecognizing(true);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            audioStreamRef.current = stream;

            gladiaSessionPromiseRef.current = initiateGladiaLiveSession();
            const { url, expires_at } = await gladiaSessionPromiseRef.current;
            if (expires_at) {
                try {
                    const exp = new Date(expires_at).getTime();
                    if (!isNaN(exp)) {
                        const remaining = exp - Date.now();
                        if (remaining < 30000) {
                            console.warn('Gladia session gần hết hạn, sẽ tạo lại ở lần ghi tiếp theo.');
                        }
                    }
                } catch (_) { /* ignore */ }
            }

            const ws = new WebSocket(url);
            wsRef.current = ws;
            const openPromise = new Promise((resolve, reject) => {
                ws.onopen = () => resolve(true);
                ws.onerror = () => reject(new Error('Không kết nối được Gladia WS'));
                ws.onclose = (e) => reject(new Error(`Đóng kết nối: ${e.code} ${e.reason}`));
            });

            const { default: RecordRTC } = await import('recordrtc');
            const recorder = new RecordRTC(stream, {
                type: 'audio',
                mimeType: 'audio/wav',
                recorderType: RecordRTC.StereoAudioRecorder,
                timeSlice: 1000,
                desiredSampRate: SAMPLE_RATE,
                numberOfAudioChannels: 1,
                async ondataavailable(blob) {
                    try {
                        if (ws.readyState !== 1) return;
                        const buffer = await blob.arrayBuffer();
                        const pcm = buffer.slice(44);
                        ws.send(pcm);
                    } catch (err) {
                        console.error('Gửi chunk lỗi', err);
                    }
                }
            });
            recorderRef.current = recorder;

            ws.onmessage = (event) => {
                try {
                    const message = JSON.parse(event.data);
                    switch (message?.type) {
                        case 'transcript': {
                            const utt = message.data?.utterance?.text || '';
                            if (message.data?.is_final) {
                                if (utt) {
                                    setInput(prev => (prev ? prev + ' ' + utt : utt));
                                }
                                setPartialText('');
                                setNotice('Đã nhận xong một câu');
                            } else {
                                setPartialText(utt);
                            }
                            break;
                        }
                        case 'error': {
                            console.error('Gladia error message:', message);
                            setNotice(message.error || 'Lỗi từ dịch vụ STT');
                            break;
                        }
                        default:
                            break;
                    }
                } catch (err) {
                    console.error('Parse WS message error', err);
                }
            };

            await openPromise;
            recorder.startRecording();
            setIsRecording(true);
            setRecognizing(false);
            setNotice('Đang ghi âm (live)... (tối đa 30s)');

            if (recordingTimeoutRef.current) {
                clearTimeout(recordingTimeoutRef.current);
            }
            recordingTimeoutRef.current = setTimeout(() => {
                setNotice('Tự dừng sau 30s');
                stopLiveRecording(true);
            }, 30000);
        } catch (err) {
            console.error('startLiveRecording error', err);
            setRecognizing(false);
            setIsRecording(false);
            let displayMsg = err.message || 'Lỗi không xác định';
            try {
                const jsonStart = displayMsg.indexOf('{');
                if (jsonStart !== -1) {
                    const jsonPart = displayMsg.substring(jsonStart);
                    const parsed = JSON.parse(jsonPart);
                    if (parsed.validation_errors) {
                        displayMsg += ' | ' + parsed.validation_errors.join('; ');
                    } else if (parsed.message && parsed.statusCode) {
                        displayMsg += ` | ${parsed.message}`;
                    }
                }
            } catch (_) { /* ignore parse error */ }
            setNotice(`Không thể bắt đầu ghi âm: ${displayMsg}`);
            try {
                if (recorderRef.current) { recorderRef.current.destroy(); recorderRef.current = null; }
                if (wsRef.current) { wsRef.current.close(); wsRef.current = null; }
                if (audioStreamRef.current) { audioStreamRef.current.getTracks().forEach(t => t.stop()); audioStreamRef.current = null; }
            } catch (_) { }
        }
    }, [initiateGladiaLiveSession, isRecording, stopLiveRecording]);
    // Cancel riêng: không merge partial
    const cancelLiveRecording = useCallback(() => {
        stopLiveRecording(false);
        setNotice('Đã huỷ ghi âm');
    }, [stopLiveRecording]);

    const toggleRecording = (evt) => {
        if (isRecording || recognizing) {
            // Nếu giữ Alt (hoặc Option) thì huỷ, ngược lại sẽ dừng & giữ partial
            if (evt && (evt.altKey || evt.metaKey)) {
                cancelLiveRecording();
            } else {
                stopLiveRecording(true);
                setNotice('Đã dừng ghi âm (đã chèn đoạn đang dở nếu có)');
            }
        } else {
            startLiveRecording();
        }
    };

    return (
        <div className="chat-detail-container">
            {/* <div className="chat-detail-header-sticky-wrapper">
                <div className="chat-detail-header">
                    Mã tư vấn: {paramGroupId === "new" ? '' : paramGroupId}
                </div>

                <div className="chat-detail-subtitle">
                    Bạn cho mình xin các thông tin để mình check xe và chi phí cho bạn nhé
                </div>
            </div> */}
            <div className="chat-detail-messages">
                {messages.map((msg, idx) =>
                    msg.sender === '0' ? (
                        <MessagePippip key={idx} message={msg.message} time={formatVNTime(msg.created_at)} />
                    ) : (
                        <MessageUser key={idx} message={msg.message} time={formatVNTime(msg.created_at)} />
                    )
                )}
                <div ref={messagesEndRef} />
            </div>
            <div className="chat-detail-input-row">
                <div className="suggestion-notification">
                    <SuggestionAndNotification
                        step={step}
                        notification={notice}
                        onSuggestionClick={handleSuggestionClick}
                    />
                </div>

                <ChatInput
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onSend={handleSendMessage}
                    onToggleRecording={toggleRecording}
                    isRecording={isRecording}
                    recognizing={recognizing}
                    isSending={isSending}
                    isFetchingStep={isFetchingStep}
                />
            </div>
        </div>
    );
}